import { ButtonV3, TypographyV3 } from '@jouzen/ecom-components';
import { usePathname } from 'next/navigation';
import { useTranslations } from 'next-intl';
import type { FocusEvent } from 'react';

import { EventType } from '@/analytics/types';
import Motion from '@/app/components/Motion';

interface HeroCopyProps {
  readonly color?: 'light' | 'dark';
  readonly topHero?: boolean;
  readonly onHeroButtonFocus: (
    event: FocusEvent<HTMLButtonElement>,
    topHero: boolean | undefined,
  ) => void;
}

const HeroCopy = ({
  color = 'light',
  topHero,
  onHeroButtonFocus,
}: HeroCopyProps): JSX.Element => {
  const t = useTranslations();
  const path = usePathname();

  const handleClick = async (): Promise<void> => {
    await window.ouraAnalytics.track(EventType.CTAClicked, {
      cta: 'shop_now',
      action: 'go_to_pdp',
      location: 'home hero',
      path,
    });
  };

  const handleFocus = (event: FocusEvent<HTMLButtonElement, Element>) => {
    onHeroButtonFocus(event, topHero);
  };

  return (
    <Motion
      data-cy="home-hero-copy"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1, type: 'tween' }}
    >
      <TypographyV3
        className="mb-6"
        Element="h2"
        variant="body-large"
        color={color}
        align="centerMdLeft"
      >
        {t('home_hero_copy')}
      </TypographyV3>
      <ButtonV3
        className="mb-8 hidden md:inline-block lg:mb-12"
        variant="primary"
        href="/product/rings"
        onClick={handleClick}
        onFocus={handleFocus}
      >
        {t('shop')}
      </ButtonV3>
    </Motion>
  );
};

export default HeroCopy;
